import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import { colors, font, radius } from "../../styles/theme/tokens";

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0 14px;
`;

const item = css`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 11px 14px;
  border-radius: ${radius.md};
  font-family: ${font.text};
  font-size: 15px;
  font-weight: 600;
  line-height: 1.2;
  text-decoration: none;

  svg {
    flex-shrink: 0;
  }
`;

export const StyledLink = styled(Link)`
  ${item};
  color: ${(props) => (props.$active ? "#FFFFFF" : colors.ink)};
  background: ${(props) => (props.$active ? colors.brand : "transparent")};
  box-shadow: ${(props) => (props.$active ? "0 6px 16px rgba(123, 120, 232, 0.35)" : "none")};
  font-weight: ${(props) => (props.$active ? 700 : 600)};
  transition: background 0.15s ease, color 0.15s ease;

  svg {
    color: ${(props) => (props.$active ? "#FFFFFF" : colors.muted)};
  }

  &:hover {
    background: ${(props) => (props.$active ? colors.brand : colors.brandSoft)};
  }
`;

export const Closed = styled.div`
  ${item};
  color: ${colors.muted};
  opacity: 0.55;
  cursor: default;

  .lock {
    margin-left: auto;
  }
`;
